import React from 'react';
import { Box } from '@mui/material';
import { BOOK_TITLE_PREVIEW_IMAGE } from '../bookOptionsAssets';

export const BookTitlePreview: React.FC = () => (
  <Box
    sx={{
      width: '100%',
      maxWidth: 355,
      height: 296,
      mx: 'auto',
      borderRadius: '16px',
      overflow: 'hidden',
      bgcolor: '#ECECEC',
    }}
  >
    <Box
      component="img"
      src={BOOK_TITLE_PREVIEW_IMAGE}
      alt="Book with spine title"
      sx={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
        display: 'block',
      }}
    />
  </Box>
);
